<div class="courses-part">
	<readonly-access [readonly]="dialogDataService.isReadonly()"></readonly-access>
	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()"
		[rows]="courses()"></grid-content>
</div>